import React from "react";
import { Link } from "react-router-dom";

import "./Music.scss";

export const Music = () => {
  return (
    <section
      className="music-experience"
      id="music"
    >

      <div className="music-experience-inner">

        <div className="music-topline">

          <div>
            <span>04</span>
            <small>MUSIC</small>
          </div>

          <Link to="/music">
            ALL MUSIC <span>↗</span>
          </Link>

        </div>

        <div className="music-intro">

          <div className="music-copy">

            <span className="music-kicker">
              LISTEN NOW
            </span>

            <h2>
              THE SOUND
              <span>OF THE MOVEMENT.</span>
            </h2>

            <p>
              Discover music from Lembawe9 and
              the wider creative universe. From
              releases to cyphers, every sound
              belongs to the same movement.
            </p>

            <div className="music-actions">

              <a
                href="https://open.spotify.com/artist/4RCCHZWNDMVcI92So1QxMD"
                target="_blank"
                rel="noreferrer"
                className="music-primary"
              >
                OPEN SPOTIFY ↗
              </a>

              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
                className="music-secondary"
              >
                YOUTUBE ↗
              </a>

            </div>

          </div>

          <div className="music-art">

            <div className="music-disc">
              <div />
            </div>

            <div className="music-art-copy">
              <small>NOW PLAYING</small>
              <strong>LEMBAWE9</strong>
              <span>MOROCCO</span>
            </div>

          </div>

        </div>

        <div className="spotify-panel">

          <div className="spotify-panel-header">

            <div>
              <small>
                STREAMING
              </small>

              <strong>
                Listen on Spotify
              </strong>
            </div>

            <span>
              ● LIVE
            </span>

          </div>

          <iframe
            title="Lembawe9 Spotify"
            src="https://open.spotify.com/embed/artist/4RCCHZWNDMVcI92So1QxMD?utm_source=generator"
            width="100%"
            height="352"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />

        </div>

      </div>

    </section>
  );
};